import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
    // agar token header me bhejna ho to:
    // prepareHeaders: (headers, { getState }) => {
    //   const token = getState()?.auth?.token;
    //   if (token) headers.set("authorization", `Bearer ${token}`);
    //   return headers;
    // },
  }),
  endpoints: (builder) => ({
    getNotificationFeed: builder.query({
      query: ({ limit = 20, cursor } = {}) => ({
        url: "/notifications/feed",
        params: { limit, cursor },
      }),
    }),

    markRead: builder.mutation({
      query: (ids) => ({
        url: "/notifications/mark-read",
        method: "POST",
        body: { ids },
      }),
    }),

    markAllRead: builder.mutation({
      query: () => ({
        url: "/notifications/mark-all-read",
        method: "POST",
      }),
    }),

    subscribePushApi: builder.mutation({
      query: ({ subscription, prefs }) => ({
        url: "/notifications/subscribe",
        method: "POST",
        body: { subscription, prefs },
      }),
    }),

    unsubscribePushApi: builder.mutation({
      query: () => ({
        url: "/notifications/unsubscribe",
        method: "POST",
      }),
    }),

    sendTestPushApi: builder.mutation({
      query: () => ({
        url: "/notifications/test",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetNotificationFeedQuery,
  useMarkReadMutation,
  useMarkAllReadMutation,
  useSubscribePushApiMutation,
  useUnsubscribePushApiMutation,
  useSendTestPushApiMutation,
} = notificationsApi;

export default notificationsApi;
